import axios from "axios";
import { getCookie } from "../utils/service";

const Axioscall = axios.create({
  baseURL: "https://vgtm.vguard.in/VG-Transportation/", // production
  // baseURL : "https://testvg.codelynks.in/VG-Transportation", //qa
});

Axioscall.interceptors.request.use(function (config) {
  const accessToken = getCookie("xAccessToken");
  const supplierId = getCookie("supplierId");
  const userId = getCookie("userId");
  const intentToken = getCookie("intentToken");
  const shareToken = getCookie("Share-Token");

  const isZonalHead = getCookie("isZonalHead");
  const intentId = getCookie("IntentId");
  config.headers["Access-Token"] = accessToken ? `${accessToken}` : "";
  config.headers["Supplier-Id"] = supplierId ? `${supplierId}` : "";
  config.headers["userId"] = userId ? `${userId}` : "";
  config.headers["Token"] = intentToken ? `${intentToken}` : "";
  config.headers["Share-Token"] = shareToken ? `${shareToken}` : "";
  config.headers["Is-Zonal-Head"] = isZonalHead ? `${isZonalHead}` : "";
  config.headers["Intent-Id"] = intentId ? `${intentId}` : "";
  return config;
});

export default Axioscall;
